import React from 'react';

export function LL37Diagram() {
  return (
    <svg viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
      {/* Background gradient */}
      <defs>
        <linearGradient id="ll37-bg-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f0f7ff" />
          <stop offset="100%" stopColor="#e1efff" />
        </linearGradient>
        <linearGradient id="ll37-bacterium-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#d0deed" />
          <stop offset="100%" stopColor="#b0cee4" />
        </linearGradient>
        <linearGradient id="ll37-tissue-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffefdb" />
          <stop offset="100%" stopColor="#ffe0c4" />
        </linearGradient>
        <filter id="ll37-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* Background */}
      <rect width="800" height="600" fill="url(#ll37-bg-gradient)" rx="15" ry="15" />

      {/* Title */}
      <text x="400" y="40" fontSize="24" fontWeight="bold" textAnchor="middle" fill="#3b82f6">
        LL-37 Dual Mechanisms of Action
      </text>

      {/* Diagram divider */}
      <line x1="400" y1="80" x2="400" y2="500" stroke="#94a3b8" strokeWidth="2" strokeDasharray="6 4" />
      
      {/* Left side title - Antimicrobial Action */}
      <text x="200" y="100" fontSize="18" fontWeight="bold" textAnchor="middle" fill="#1e40af">
        Antimicrobial Action
      </text>
      
      {/* Right side title - Wound Healing */}
      <text x="600" y="100" fontSize="18" fontWeight="bold" textAnchor="middle" fill="#047857">
        Wound Healing
      </text>

      {/* Bacterial membrane disruption - left side */}
      <circle cx="200" cy="200" r="70" fill="url(#ll37-bacterium-gradient)" stroke="#64748b" strokeWidth="2" />
      <text x="200" y="180" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#334155">
        Bacterial Cell
      </text>
      <text x="200" y="200" fontSize="14" textAnchor="middle" fill="#334155">
        Membrane
      </text>

      {/* LL-37 attacking bacterial membrane */}
      <g transform="translate(120, 200)">
        <rect x="-30" y="-12" width="60" height="24" rx="12" ry="12" fill="#93c5fd" stroke="#2563eb" strokeWidth="2" />
        <text x="0" y="5" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          LL-37
        </text>
      </g>
      
      {/* Arrows showing LL-37 attacking membrane */}
      <defs>
        <marker id="ll37-arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#64748b" />
        </marker>
      </defs>
      
      <line x1="150" y1="190" x2="180" y2="170" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      <line x1="150" y1="210" x2="180" y2="230" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      
      {/* Membrane disruption representation */}
      <path d="M160,150 Q180,145 190,155 Q200,165 210,155 Q220,145 240,150" 
            fill="none" stroke="#ef4444" strokeWidth="2" />
      <path d="M160,250 Q180,255 190,245 Q200,235 210,245 Q220,255 240,250" 
            fill="none" stroke="#ef4444" strokeWidth="2" />
            
      {/* Biofilm disruption - left bottom */}
      <rect x="120" y="320" width="160" height="50" rx="5" ry="5" fill="#d4d4d8" stroke="#71717a" strokeWidth="2" />
      <text x="200" y="340" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#3f3f46">
        Bacterial Biofilm
      </text>
      <text x="200" y="360" fontSize="12" textAnchor="middle" fill="#3f3f46">
        Matrix Disruption
      </text>
      
      {/* LL-37 attacking biofilm */}
      <g transform="translate(80, 340)">
        <rect x="-30" y="-12" width="60" height="24" rx="12" ry="12" fill="#93c5fd" stroke="#2563eb" strokeWidth="2" />
        <text x="0" y="5" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          LL-37
        </text>
      </g>
      
      <line x1="110" y1="340" x2="140" y2="340" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      
      {/* Result box - left side */}
      <g transform="translate(200, 420)">
        <rect x="-100" y="-25" width="200" height="50" rx="10" ry="10" fill="#fee2e2" stroke="#ef4444" strokeWidth="2" />
        <text x="0" y="0" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#b91c1c">
          Direct Pathogen
        </text>
        <text x="0" y="20" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#b91c1c">
          Elimination
        </text>
      </g>
      
      {/* Tissue regeneration - right side */}
      <rect x="520" y="160" width="160" height="80" rx="10" ry="10" fill="url(#ll37-tissue-gradient)" stroke="#ea580c" strokeWidth="2" />
      <text x="600" y="190" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#9a3412">
        Keratinocytes
      </text>
      <text x="600" y="210" fontSize="14" textAnchor="middle" fill="#9a3412">
        &amp; Fibroblasts
      </text>
      
      {/* LL-37 interacting with FPR2 receptor */}
      <g transform="translate(480, 190)">
        <rect x="-30" y="-12" width="60" height="24" rx="12" ry="12" fill="#93c5fd" stroke="#2563eb" strokeWidth="2" />
        <text x="0" y="5" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          LL-37
        </text>
      </g>
      
      <rect x="520" y="170" width="50" height="20" rx="5" ry="5" fill="#a7f3d0" stroke="#10b981" strokeWidth="2" />
      <text x="545" y="185" fontSize="12" fontWeight="bold" textAnchor="middle" fill="#047857">
        FPR2
      </text>
      
      <line x1="510" y1="190" x2="530" y2="180" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      
      {/* Angiogenesis - right side */}
      <g transform="translate(650, 340)">
        <path d="M0,0 C10,-20 30,-20 30,0 C30,20 50,20 50,0 C50,-20 70,-20 70,0" 
              fill="none" stroke="#dc2626" strokeWidth="3" />
        <path d="M0,0 C10,20 30,20 30,0 C30,-20 50,-20 50,0 C50,20 70,20 70,0" 
              fill="none" stroke="#dc2626" strokeWidth="3" />
        <text x="35" y="-10" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#b91c1c">
          Blood Vessels
        </text>
      </g>
      
      {/* LL-37 promoting angiogenesis */}
      <g transform="translate(550, 340)">
        <rect x="-30" y="-12" width="60" height="24" rx="12" ry="12" fill="#93c5fd" stroke="#2563eb" strokeWidth="2" />
        <text x="0" y="5" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          LL-37
        </text>
      </g>
      
      <line x1="580" y1="340" x2="620" y2="340" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      
      {/* Result box - right side */}
      <g transform="translate(600, 420)">
        <rect x="-100" y="-25" width="200" height="50" rx="10" ry="10" fill="#dcfce7" stroke="#22c55e" strokeWidth="2" />
        <text x="0" y="0" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#15803d">
          Enhanced Wound
        </text>
        <text x="0" y="20" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#15803d">
          Healing &amp; Angiogenesis
        </text>
      </g>
      
      {/* Connecting lines from mechanisms to results */}
      <line x1="200" y1="375" x2="200" y2="390" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      <line x1="600" y1="375" x2="600" y2="390" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      
      {/* Bottom combined effect */}
      <g transform="translate(400, 520)">
        <rect x="-200" y="-25" width="400" height="50" rx="10" ry="10" fill="#dbeafe" stroke="#3b82f6" strokeWidth="2" />
        <text x="0" y="0" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          LL-37: Bridging Antimicrobial Defense
        </text>
        <text x="0" y="20" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          with Tissue Regeneration
        </text>
      </g>
      
      {/* Connecting lines to final result */}
      <line x1="200" y1="450" x2="300" y2="510" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
      <line x1="600" y1="450" x2="500" y2="510" stroke="#64748b" strokeWidth="2" markerEnd="url(#ll37-arrowhead)" />
    </svg>
  );
}